<ion-button ionBackButton (click)="activated.emit()">
  <ion-icon [src]="iconSrc"></ion-icon>
</ion-button>
